/* tslint:disable */
/* eslint-disable */
/**
 * Care& API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.9.4
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import type {
  Article,
  ErrorResponse,
  Section,
} from '../models';
import {
    ArticleFromJSON,
    ArticleToJSON,
    ErrorResponseFromJSON,
    ErrorResponseToJSON,
    SectionFromJSON,
    SectionToJSON,
} from '../models';

export interface AddArticleRequest {
    article: Article;
}

export interface AddSectionRequest {
    section: Section;
}

export interface DeleteArticleRequest {
    id: string;
}

export interface DeleteSectionRequest {
    sectionId: string;
}

export interface GetArticlesRequest {
    sectionId?: string;
}

export interface GetFeaturesRequest {
    featureName?: string;
}

/**
 * 
 */
export class DocumentationApi extends runtime.BaseAPI {

    /**
     * Adds or edits a documentation article (Roles: admin, physician)
     */
    async addArticleRaw(requestParameters: AddArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Article>> {
        if (requestParameters.article === null || requestParameters.article === undefined) {
            throw new runtime.RequiredError('Article','Required parameter requestParameters.article was null or undefined when calling addArticle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/articles`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: ArticleToJSON(requestParameters.article),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => ArticleFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addArticleRequestOptionsRaw(requestParameters: AddArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.article === null || requestParameters.article === undefined) {
            throw new runtime.RequiredError('Article','Required parameter requestParameters.article was null or undefined when calling addArticle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/articles`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: ArticleToJSON(requestParameters.article),
        };
        return responseConfig
    }

    /**
     * Adds or edits a documentation article (Roles: admin, physician)
     */
    async addArticle(requestParameters: AddArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Article> {
        const response = await this.addArticleRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Adds or edits a documentation section (Roles: admin, physician)
     */
    async addSectionRaw(requestParameters: AddSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Section>> {
        if (requestParameters.section === null || requestParameters.section === undefined) {
            throw new runtime.RequiredError('Section','Required parameter requestParameters.section was null or undefined when calling addSection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/sections`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: SectionToJSON(requestParameters.section),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => SectionFromJSON(jsonValue));
    }

    /**
        Request Config Getter
     */
    addSectionRequestOptionsRaw(requestParameters: AddSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.section === null || requestParameters.section === undefined) {
            throw new runtime.RequiredError('Section','Required parameter requestParameters.section was null or undefined when calling addSection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/sections`,
            method: 'POST' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
            body: SectionToJSON(requestParameters.section),
        };
        return responseConfig
    }

    /**
     * Adds or edits a documentation section (Roles: admin, physician)
     */
    async addSection(requestParameters: AddSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Section> {
        const response = await this.addSectionRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Deletes an article (Roles: admin, physician)
     */
    async deleteArticleRaw(requestParameters: DeleteArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteArticle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteArticleRequestOptionsRaw(requestParameters: DeleteArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling deleteArticle.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Deletes an article (Roles: admin, physician)
     */
    async deleteArticle(requestParameters: DeleteArticleRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteArticleRaw(requestParameters, initOverrides);
    }

    /**
     * Delete a section (Roles: admin, physician)
     */
    async deleteSectionRaw(requestParameters: DeleteSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.sectionId === null || requestParameters.sectionId === undefined) {
            throw new runtime.RequiredError('sectionId','Required parameter requestParameters.sectionId was null or undefined when calling deleteSection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters.sectionId))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.VoidApiResponse(response);
    }

    /**
        Request Config Getter
     */
    deleteSectionRequestOptionsRaw(requestParameters: DeleteSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        if (requestParameters.sectionId === null || requestParameters.sectionId === undefined) {
            throw new runtime.RequiredError('sectionId','Required parameter requestParameters.sectionId was null or undefined when calling deleteSection.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/sections/{sectionId}`.replace(`{${"sectionId"}}`, encodeURIComponent(String(requestParameters.sectionId))),
            method: 'DELETE' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Delete a section (Roles: admin, physician)
     */
    async deleteSection(requestParameters: DeleteSectionRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<void> {
        await this.deleteSectionRaw(requestParameters, initOverrides);
    }

    /**
     * Gets all documentation articles (Roles: admin, physician)
     */
    async getArticlesRaw(requestParameters: GetArticlesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Article>>> {
        const queryParameters: any = {};

        if (requestParameters.sectionId !== undefined) {
            queryParameters['section_id'] = requestParameters.sectionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/articles`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ArticleFromJSON));
    }

    /**
        Request Config Getter
     */
    getArticlesRequestOptionsRaw(requestParameters: GetArticlesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.sectionId !== undefined) {
            queryParameters['section_id'] = requestParameters.sectionId;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/articles`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all documentation articles (Roles: admin, physician)
     */
    async getArticles(requestParameters: GetArticlesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Article>> {
        const response = await this.getArticlesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all UI help features (Roles: admin, physician)
     */
    async getFeaturesRaw(requestParameters: GetFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Article>>> {
        const queryParameters: any = {};

        if (requestParameters.featureName !== undefined) {
            queryParameters['feature_name'] = requestParameters.featureName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/features`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(ArticleFromJSON));
    }

    /**
        Request Config Getter
     */
    getFeaturesRequestOptionsRaw(requestParameters: GetFeaturesRequest, initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        if (requestParameters.featureName !== undefined) {
            queryParameters['feature_name'] = requestParameters.featureName;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/features`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all UI help features (Roles: admin, physician)
     */
    async getFeatures(requestParameters: GetFeaturesRequest = {}, initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Article>> {
        const response = await this.getFeaturesRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     * Gets all documentation sections (Roles: admin, physician)
     */
    async getSectionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<runtime.ApiResponse<Array<Section>>> {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }

        const response = await this.request({
            path: `/documentation/sections`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(SectionFromJSON));
    }

    /**
        Request Config Getter
     */
    getSectionsRequestOptionsRaw(initOverrides?: RequestInit | runtime.InitOverrideFunction): runtime.RequestOpts {
        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.apiKey) {
            headerParameters["Authorization"] = this.configuration.apiKey("Authorization"); // Bearer authentication
        }


        const responseConfig = {
            path: `/documentation/sections`,
            method: 'GET' as runtime.HTTPMethod,
            headers: headerParameters,
            query: queryParameters,
        };
        return responseConfig
    }

    /**
     * Gets all documentation sections (Roles: admin, physician)
     */
    async getSections(initOverrides?: RequestInit | runtime.InitOverrideFunction): Promise<Array<Section>> {
        const response = await this.getSectionsRaw(initOverrides);
        return await response.value();
    }

}
